export default __webpack_public_path__ + "static/media/cp_geo_bs.929b1134.svg";